import { html } from 'lit';
import { faPinterest } from '@fortawesome/free-brands-svg-icons/faPinterest';
import ShareBtn from './ShareBtn';
import { getFAIcon, generateEnhancedShareUrl } from '../../masonry-utils';

// eslint-disable-next-line
import styles from '!!lit-css-loader!postcss-loader!sass-loader!./web-share.scss';

class PinterestShareBtn extends ShareBtn {
  static styles = [styles];

  static get properties() {
    return {
      ...super.properties,
      post: { type: Object },
    };
  }

  constructor() {
    super();
    this.icon = faPinterest;
    this.color = '#E60023';
  }

  /**
   * Gets the Pinterest share URL with enhanced URL tracking and media
   * @returns {string} Pinterest share URL with media parameter
   */
  get shareURL() {
    const url = this.post ? generateEnhancedShareUrl(this.post) : window.location.href;
    const media = this.post?.media?.[0]?.medium || '';
    return `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(
      url
    )}&media=${encodeURIComponent(media)}`;
  }

  /**
   * Checks if Pinterest sharing should be available
   * @returns {boolean} True if post has media for Pinterest sharing
   */
  get shouldRender() {
    // Only show Pinterest share button if post has media, matching ModalShareButtons logic
    return this.post?.media && this.post.media[0];
  }

  /**
   * Handles Pinterest share click with post-specific URL
   */
  clickHandler = () => {
    const url = this.post ? generateEnhancedShareUrl(this.post) : window.location.href;
    window.open(
      `https://pinterest.com/pin/create/bookmarklet/?url=${encodeURIComponent(url)}`,
      '',
      'toolbar=no, location=no, status=no, menubar=no, resizable=no, width=550, height=400'
    );
  };

  render() {
    // Conditional rendering logic matching ModalShareButtons
    if (!this.shouldRender) {
      return html``;
    }

    return html`
      <a
        href=${this.shareURL}
        target="_blank"
        rel="noopener noreferrer"
        class="web-share__btn"
        @click=${this.clickHandler}
      >
        ${getFAIcon(this.icon)}
      </a>
    `;
  }
}

export default PinterestShareBtn;
